import React, { useState, useEffect } from 'react';
import { LISTING_TYPE } from '../platformUtils';

// hooks
import useSampleProperties from './useSampleProperties';
import { useLocation, useParams } from 'react-router-dom';

function useSearchedProperties() {
    const [searchedProperties, setSearchedProperties] = useState(useSampleProperties(12));
    let location = useLocation();
    let params = useParams();
    //console.log(params, location);
    // TODO: remove dummy data
    
    useEffect(() => {
        let params = new URLSearchParams(location.search);
        
        // TODO: get correct search filters & sorts from url params
        // category
        // price
        // location
        // metaverse world

        //TODO: retrieve filtered values from search engine
        
        // setSearchedProperties(filteredProperties);
    }, [ location, params ]);

    return searchedProperties;
}
export default useSearchedProperties;